<template>
  <el-dialog
      title="发票抬头信息"
      :visible.sync="visible"
      modal-append-to-body
      width="500px"
      :before-close="handleClose">
    <el-descriptions border :column="1">
      <el-descriptions-item label="发票抬头名称">{{ ruleForm?.headerTitle }}</el-descriptions-item>
      <el-descriptions-item label="信用代码">{{ ruleForm?.taxpayerNumber }}</el-descriptions-item>
      <el-descriptions-item label="邮箱">{{ ruleForm?.email }}</el-descriptions-item>
    </el-descriptions>
  </el-dialog>
</template>

<script>
export default {
  name: "invoiceHeader",
  props:{
    visible: {
      type: Boolean,
      default: false
    },
    tradeNo: {
      type: String,
      default: ''
    },
  },
  created() {
    this.getInvoiceInfo()
  },
  data(){
    return{
      ruleForm: {}
    }
  },
  methods:{
    getInvoiceInfo(){
      this.loading = true
      this.$http.get(this.$api.customerEnterprise.getInvoiceInfo + this.tradeNo).then((res) => {
        if (res.data.code == 200) {
          this.ruleForm = res.data.data
          this.loading = false;
        }else {
          this.$message.error(res.data.msg);
          this.loading = false
        }
      })
    },
    handleClose() {
      this.$confirm('确认关闭？')
          .then(()=> {
            this.updateDialog(false)
          })
          .catch(() => {});
    },
    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">

</style>
